import gql from "graphql-tag";

export default gql`
  mutation CreateSite(
    $name: String!
    $physicalAddress: String
    $region: String
    $companyId: ID!
  ) {
    createSite(
      name: $name
      physicalAddress: $physicalAddress
      region: $region
      companyId: $companyId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreateSite.ts